import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';

@Component({
    selector: 'app-nonagri-agri-property-values-en-v2',
    templateUrl: './nonagri-agri-property-values-en-v2.component.html',
    styleUrls: ['./nonagri-agri-property-values-en-v2.component.css'],
    standalone: false
})
export class NonagriAgriPropertyValuesEnV2Component implements OnInit, OnChanges {
  @Input() printActive: boolean
  @Input() returnData: any
  @Input() isSinglePageReturn: boolean
  nonAgriProperties = [];
  nonAgriPropertiesAdvance = [];
  agriProperties = [];

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.nonAgriProperties = [];
    this.nonAgriPropertiesAdvance = [];
    this.agriProperties = [];

    this.returnData?.headSummery?.assetsAndLiabilities?.forEach(item=>{
      if(item.secondSubTypeKey === 'non_agricultural_property_child'){
        this.nonAgriProperties = this.nonAgriProperties.concat(item.detailsOfAL)
      }
      if(item.secondSubTypeKey === 'advance_made_for_non_agricultural_property'){
        this.nonAgriPropertiesAdvance = this.nonAgriPropertiesAdvance.concat(item.detailsOfAL)
      }
      if(item.firstSubTypeKey === 'agricultural_property'){
        this.agriProperties = this.agriProperties.concat(item.detailsOfAL)
      }
    })
  }

}
